import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { auth } from '../../api/endpoints';
import { BrandScreen } from '../../components/layout/Screens';
import { Button } from '../../components/ui/Button';
import { Field } from '../../components/ui/Field';
import { SiroccoLogo } from '../../theme/illustrations';
import { t } from '../../i18n';

/**
 * Mot de passe oublie.
 * On confirme toujours l'envoi, sans dire si l'adresse existe : cela
 * evite de reveler qui est inscrit.
 */
export function ForgotPasswordScreen() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    setError(null);
    setPending(true);
    try {
      await auth.forgotPassword(email);
      setSent(true);
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : t.auth.oubli.impossible);
    } finally {
      setPending(false);
    }
  }

  return (
    <BrandScreen>
      <div className="auth auth--register">
        <div className="auth__logo">
          <SiroccoLogo markSize={50} />
        </div>

        <h1 className="auth__title">{t.auth.oubli.titre}</h1>

        {sent ? (
          <>
            <p className="auth__switch auth__switch--top">
              {t.auth.oubli.envoye(email)}
            </p>
            <div className="auth__form">
              <Link to="/login">
                <Button variant="brand" block>
                  {t.auth.champs.retourConnexion}
                </Button>
              </Link>
            </div>
          </>
        ) : (
          <>
            <p className="auth__switch auth__switch--top">
              {t.auth.oubli.consigne}
            </p>
            <form className="auth__form" onSubmit={onSubmit} noValidate>
              <Field
                label={t.auth.champs.email}
                type="email"
                inputMode="email"
                placeholder={t.auth.champs.exempleEmail}
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                error={error}
              />
              <Button type="submit" variant="brand" block loading={pending} className="auth__submit">
                {t.auth.oubli.envoyer}
              </Button>
            </form>
            <p className="auth__switch">
              <Link to="/login">{t.auth.champs.retourConnexion}</Link>
            </p>
          </>
        )}
      </div>
    </BrandScreen>
  );
}
